<header>
    <h2>Create Item</h2>
</header>

<div *ngFor="let type of types">
    <button (click)="createItem(type.name)" mat-raised-button color="primary" class="create-button">
        Create {{type.nicename}}
    </button>
</div>

